import React, {Component} from "react";
import styled from "styled-components";
import { Flex } from "../components";

const ModalWrapper = styled(Flex)`
  display: ${({ open }) => (open ? "display" : "none")};
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  margin: 0 auto;
  background: rgba(0, 0, 0, 0.1);
`;

const ModalTextWrapper = styled(Flex)`
  width: 25vw;
  padding: 2em;
  border: 1px solid #ccc;
  border-radius: .5em;
  background: #fff;
  @media(max-width:767px){
    width:300px !important;
  }
`;
const Cancel = styled.p`
  color: #9a9a9a;
  font-weight: 600;
  font-size: 18px;
`
const Submit = styled.p`
  color: #673AB7;
  font-weight: 600;
  font-size: 18px;
  margin-left: 50px;
`

class Modal extends Component {
    state = {
        code: null,
        open: false,
        notValid: false
    }

    onChangeHandler=(event)=>{
        this.setState({
            code: event.target.value
        })
    }
    openModalHandler = ()=>{
        this.setState({open: true, notValid: false})
    }

    handleModalToggle = ()=>{
        document.getElementById('input').value=null;
        this.setState({code: null, open: false, notValid: false, loading: false})
    }
    handleSubmit = async ()=>{
        console.log(this.props.tid)
        console.log(this.state.code)
        if (!this.state.code) {
            this.setState({notValid: true})
            return
        }
        this.setState({loading:true})
        let data = await this.props.submit(this.props.tid,this.state.code)
        console.log(data)
        if (data == 'true') {
            this.setState({code: null, open: false, notValid: false, loading: false})
            this.props.startTest(this.props.tid, this.props.results)
        } else {
            this.setState({notValid: true, loading: false})
        }
    }
    render () {
        return (
            <ModalWrapper center open={this.state.open}>
                <ModalTextWrapper column>
                    <div style={{margin: 'auto', textAlign: 'center'}}>
                        <p style={{fontSize:'14px',fontWeight:'bold',marginBottom:'20px', margin: '10px auto 20px auto'}} >Please enter the test code</p>
                        <input id='input' style={{height: '20px', width: '200px', marginBottom: '20px'}} value={this.state.code} onChange={this.onChangeHandler} ></input>
                        {this.state.notValid ? <p style={{fontSize:'14px',color: 'red',marginBottom:'20px', margin: ' auto auto'}}>please enter a valid code</p> : null}
                        {this.state.loading ? <p style={{fontSize:'14px',marginBottom:'20px', margin: ' auto auto'}}>Submitting....</p> : null}

                    </div>
                
                <Flex justifyBetween style = {{margin: 'auto'}}>
                    <Cancel  onClick={this.handleModalToggle}>CANCEL</Cancel>
                    <Submit onClick={()=>this.handleSubmit(this.state.code)}>SUBMIT</Submit>
                </Flex>
                </ModalTextWrapper>
            </ModalWrapper>
        )
    }
}

export default Modal;
